import React, { Component } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import * as Location from 'expo-location';
import * as Permissions from 'expo-permissions';
import CustomText from '../customText/CustomText';
import { LocationMap } from '../locationMap/LocationMap';
// import ApiKeys from '../../../constants/ApiKeys';
import theme from '../../constants/theme.style.js';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
  },
  ifLocationButtonContainer: {
    width: '70%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 20,
  },
  ifLocationButton: {
    padding: 20,
    margin: 10,
    backgroundColor: theme.GREEN_DARKER_COLOR,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
  },
  ifLocationButtonActive: {
    backgroundColor: theme.GREY_LIGHTER_COLOR,
  },
  ifLocationButtonText: {
    color: theme.WHITE_COLOR,
  },
  label: {
    margin: 8,
  },
});

export default class LocationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusMessage: '',
      permissionGranted: false,
      isSelected: false,
      city: '',
      country: '',
      latitude: '',
      longitude: '',
    };
  }

  getReverseGeoLocation = async (lat, long) => {
    const { onAddLocation } = this.props;

    try {
      let city = '';
      let country = '';

      const response = await fetch(
        `https://cors-anywhere.herokuapp.com/https://reverse.geocoder.ls.hereapi.com/6.2/reversegeocode.json?prox=${lat},${long}%2C250&mode=retrieveAddresses&maxresults=1&gen=9&apiKey=asfsgtwVaioE6nDW7aPw6egFrtsEtOE_osdsSEeh-LU`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const body = await response.json();
      switch (response.status) {
        case 200:
          city = body.Response.View[0].Result[0].Location.Address.City;
          country = body.Response.View[0].Result[0].Location.Address.Country;
          this.setState({
            statusMessage: '',
            city,
            country,
          });
          onAddLocation(`${city}, ${country}`);
          break;
        default:
      }
    } catch {
      // error -> do nothing
    }
  };

  getLocationAsync = async () => {
    this.setState({
      statusMessage: 'Acquiring location...',
    });
    await Location.getCurrentPositionAsync({})
      .then((res) => {
        this.getReverseGeoLocation(res.coords.latitude, res.coords.longitude);
        this.setState({
          latitude: res.coords.latitude,
          longitude: res.coords.longitude,
        });
      })
      .catch(() => {
        // error -> do nothing
      });
  };

  askForPermission = async () => {
    await Permissions.askAsync(Permissions.LOCATION)
      .then((res) => {
        if (res.status === 'granted') {
          this.setState({
            permissionGranted: true,
          });
          this.getLocationAsync();
        }
        if (res.status === 'denied') {
          this.setState({
            statusMessage: 'Access to location was denied!',
          });
        }
      })
      .catch((err) => {
        this.setState({
          statusMessage: err,
        });
      });
  };

  addLocation = () => {
    this.setState({ isSelected: true });
    this.askForPermission();
  };

  removeLocation = () => {
    const { onAddLocation } = this.props;
    this.setState({ isSelected: false });
    onAddLocation('undefined');
  };

  render() {
    const {
      statusMessage,
      isSelected,
      permissionGranted,
      city,
      country,
      latitude,
      longitude,
    } = this.state;
    const { testing } = this.props;

    return (
      <View style={styles.container}>
        <View style={styles.ifLocationButtonContainer}>
          <TouchableOpacity
            testID="yesButton"
            onPress={this.addLocation}
            style={[styles.ifLocationButton, !isSelected ? styles.ifLocationButtonActive : null]}
          >
            <CustomText style={styles.ifLocationButtonText}>Yes</CustomText>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={this.removeLocation}
            style={[styles.ifLocationButton, isSelected ? styles.ifLocationButtonActive : null]}
          >
            <CustomText style={styles.ifLocationButtonText}>No</CustomText>
          </TouchableOpacity>
        </View>
        {isSelected && (
          <View>
            <CustomText testID="statusMessage">{statusMessage}</CustomText>
            {(city && country) !== '' && <CustomText>{`${city}, ${country}`}</CustomText>}
            {permissionGranted && (
              <LocationMap
                testID="mapView"
                latitude={latitude}
                longitude={longitude}
                testing={testing}
              />
            )}
          </View>
        )}
      </View>
    );
  }
}
